import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { RequestSearchSupporters, ResponseSearchSupporters } from 'src/utilities/restApi/kanri/types/searchSupporters';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

export const searchSupporters = async (data: RequestSearchSupporters, controller?: AbortController) => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers, signal: controller?.signal };

  return new Promise<SuccessResponse<ResponseSearchSupporters>>((resolve, reject) => {
    restApi()
      .post<SuccessResponse<ResponseSearchSupporters>>('/search/supporterlist', data, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        if (error.message === 'canceled') {
          return reject('canceled');
        } else {
          return reject(error.response?.data);
        }
      });
  });
};
